<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Feature Flag</h4>
          <router-link to="/app/featureflag">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div v-if="showItem">
          <el-select class=""
                      size="large"
                      filterable
                      placeholder="Digite para filtar"
                      v-model="compSelect">
            <el-option v-for="option in companyList"
                        class=""
                        :value="option.id"
                        :label="option.name"
                        :key="option.index">
            </el-option>
          </el-select>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData()">
            <el-table-column label="ID" property="id" ></el-table-column>
            <el-table-column label="Tipo" property="flag_type" ></el-table-column>
            <el-table-column label="VM" property="vm" ></el-table-column>
            <el-table-column label="Feature" property="feature" ></el-table-column>
            <el-table-column label="Status" property="active" ></el-table-column>
            <el-table-column label="Ações" width="90">
              <div class="td-actions" slot-scope="props" >
                <a
                  class="btn btn-warning btn-link btn-xs" 
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { selection } from 'd3';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select
  },
  data () {
    return {
      compSelect : '',
      dados: [],
      featureFlagOpt: [],
      featureFlag: [],
      featureOpt: [],
      vmList: [],
      tabela: [],
      grade: [],
      companyList: [],
      showTable: true,
      showSelect: false
    }
  },
  mounted () {
    this.getListCompany()
    this.$store.dispatch('general/options').then(data =>{
      this.featureOpt = data.actions.POST
    })
    this.$watch('compSelect', () => {
      this.init()
    })
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.compSelect = Number(ciaID)
    }
  },
  computed: {
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
  },
  methods: {
    handleEdit(i, row) {
      this.$router.push(`/app/featureflag/${row.id}`);
    },
    init () {
      console.log('comp', this.compSelect)
      this.$store.dispatch("general/flag", { id: this.compSelect}).then(data => {
        this.featureFlag = data.results
      })
      this.getVM()
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(data => {
        this.companyList = data
      })
    },
    getVM () {
      this.$store.dispatch('machines/get', {id: '?company=' + this.compSelect}).then(data =>{
        this.vmList = data
      }).then (()=>{
          this.$store.dispatch('lockers/get',{id: '?company=' + this.compSelect}).then(resp =>{
            for (let index = 0; index < resp.results.length; index++) {
              this.vmList.push(resp.results[index])
            }
          })
          this.tableData()
        })
    },
    tableData() {
      const populated = this.featureFlag.map(v =>{
        let flag_type, active, vm, feature
        if (v.flag_type === 'C') {
          flag_type = 'Companhia'
        } 
        if (v.flag_type === 'V') {
          flag_type = 'Vending Machine'
        } 
        if (v.active === true) {
          active = 'Ativado'
        } 
        if (v.active === false) {
          active = 'Desativado'
        } 
        if (v.vm) {
          vm = this.vmList.filter(e => e.id == v.vm);
          vm = vm[0].location
        }
        if (v.feature) {
          feature = this.featureOpt.feature.choices.filter(e => e.value == v.feature)
          feature = feature[0].display_name
        }
        return { ...v, flag_type, active, vm, feature };
      })
      console.log('pop', populated)
      return populated
    },
    handleDelete(i, row) {
      const itemName = "Feature";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.showTable = false
          this.$store.dispatch("general/flagDelete", { id: row.id }).then(() =>{
            this.dados = []
            swal.fire({
              title: "Pronto!",
              text: `${itemName} excluído(a).`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(result =>{
              if (result.value) {
                // window.location.reload()
                this.$store.dispatch("general/list").then(()=>{
                  this.init()
                })
              }
            })
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
